<template>
  <v-container fluid>
    <v-layout row wrap text-center winners__not-found v-if="serverError">
      <v-flex xs12>
        <h1>{{ serverError }}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="!serverError">
      <v-flex xs12>
        <h1>{{ $t('pagesSite.recall.title') }}</h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout form__row row wrap>
      <v-flex xs12>
        <v-chip-group
          v-model="filterActive"
          active-class="primary accent-4 white--text"
          column
        >
          <v-chip>{{ $t('pagesSite.recall.tabWiam') }}</v-chip>
          <v-chip>{{ $t('pagesSite.recall.tabSplit') }}</v-chip>
        </v-chip-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap block winners mx-0>
      <v-flex xs12 px-0 v-if="isLoaded && !serverError">
        <v-data-table
          :headers="headers"
          :items="listFiltered"
          :loading="!isLoaded"
          sort-deprecated-by="guaranteeing"
          :sort-desc="true"
          :footer-props="{ 'items-per-page-options': [250] }"
          :items-per-page="250"
          class="winners__table"
        >
          <v-progress-linear
            v-slot:progress
            color="primary"
            v-if="isLoaded"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item="{ item }">
            <tr @click="openLink(item.id)">
              <td class="text-center">
                {{ item.created_at | formatDateTime }}
              </td>
              <td class="text-left">
                {{ item.name }}
              </td>

              <td class="text-center">
                {{ item.phone | formatPhone }}
              </td>
              <td class="text-center">{{ item.email }}</td>
              <td class="text-center">
                <v-chip
                  class="ma-2"
                  :color="getStatusColor(item.status)"
                  label
                  outlined
                >
                  {{ getStatusName(item.status) }}
                </v-chip>
              </td>
              <td class="text-center">
                <a :href="getUrl(item.url)" target="_blank" v-if="item.url">{{
                  item.url
                }}</a>
                <span v-else>-</span>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <div class="winners--empty">
              <h2>{{ $t('pagesSite.recall.emptyData') }}</h2>
            </div>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 mt-5 v-else>
        <skeleton />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import statusNames from "@/utils/data/statuses";
import { mask } from "vue-the-mask";
import Skeleton from "@/components/skeleton";
import formatDate from "@/mixins/filters/formatDate";
import formatDateTime from "@/mixins/filters/formatDateTime";

import formatPrice from "@/mixins/filters/formatPrice";
import formatPhone from "@/mixins/filters/formatPhone";
import i18n from "@/services/i18n";


export default {
  name: "SiteRecall",
  directives: { mask },
  mixins: [formatDate, formatPrice, formatPhone, formatDateTime],
  data: () => ({
    list: null,
    isLoaded: false,
    filterActive: 0,

    columns: [],
    pagination: {
      rowsPerPage: 500,
      /*sortBy: "guaranteeing",*/
      /*descending: true*/
    },
    serverError: null,
    statusNames,
  }),

  components: { Skeleton },
  methods: {
    getParamsValue(params, name) {
      if (params && params[name]) return params[name];
      return null;
    },

    getUrl(url) {
      return `https://wiam.ru/${url}`;
    },

    getStatusName(status) {
      return this.statusNames.siteRecall[status].name
        ? this.statusNames.siteRecall[status].name
        : "";
    },

    getStatusColor(status) {
      return this.statusNames.siteRecall[status].color
        ? this.statusNames.siteRecall[status].color
        : "";
    },

    getSocketMessage(message) {
      switch (message.type) {
        case 2:
          if (message && message.action === "updateCallbackPhone") {
            this.getList();
          }
          break;
      }
    },

    async getList() {
      this.isLoaded = false;

      await apiCallTrue({
        url: "v1/site/index",
      })
        .then((response) => {
          this.list = response.data.data;
          this.isLoaded = true;
        })
        .catch((error) => {
          this.serverError = error.message;
        });
    },

    openLink(id) {
      /*Object.assign(document.createElement("a"), {
        target: "_blank",
        href: "/tenders/" + id,
      }).click();*/
      console.log("ONCLICK", id);
    },

    getColumns(role) {
      console.log(role);
      return [
        {
          text: i18n.t('pagesSite.recall.table.fields.created_at'),
          name: i18n.t('pagesSite.recall.table.fields.created_at'),
          value: "created_at",
          align: "center",
          sortable: true,
          disabledColumn: false,
        },
        {
          text: i18n.t('pagesSite.recall.table.fields.name'),
          name: i18n.t('pagesSite.recall.table.fields.name'),
          value: "name",
          align: "left",
          sortable: true,
          disabledColumn: false,
        },

        {
          text: i18n.t('pagesSite.recall.table.fields.phone'),
          name: i18n.t('pagesSite.recall.table.fields.phone'),
          value: "phone",
          align: "center",
          sortable: false,
          disabledColumn: false,
        },

        {
          text: i18n.t('pagesSite.recall.table.fields.email'),
          name: i18n.t('pagesSite.recall.table.fields.email'),
          value: "email",
          align: "center",
          sortable: false,
          disabledColumn: false,
        },

        {
          text: i18n.t('pagesSite.recall.table.fields.status'),
          name: i18n.t('pagesSite.recall.table.fields.status'),
          value: "status",
          align: "center",
          sortable: true,
          disabledColumn: false,
        },

        {
          text: i18n.t('pagesSite.recall.table.fields.url'),
          name: i18n.t('pagesSite.recall.table.fields.url'),
          value: "url",
          align: "left",
          sortable: false,
          disabledColumn: false,
        },
      ];
    },
  },
  computed: {
    headers() {
      return this.columns;
    },
    ...mapState({
      role: (state) => state.user.profile.role,
      wSocket: (state) => state.wSocket.message,
    }),
    roleCheck() {
      return this.role ? this.role : 0;
    },

    listFiltered() {
      if (!this.list) return [];
      return this.list.filter((val) => {
        if (this.filterActive == 0) return val.system == null;
        return val.system == this.filterActive;
      });
    },
  },
  mounted() {
    this.columns = this.getColumns(this.roleCheck);
    this.getList();
  },

  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
};
</script>

<style lang="scss">
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child),
table.v-table thead th {
  padding: 0 10px !important;
}

.filters {
  padding: 16px 0;

  &--disabled {
    opacity: 0.2;
  }

  .v-select__selections {
    strong {
      font-size: 13px;
      font-weight: 400;
      padding-left: 10px;
    }
    input {
      width: 5px;
      padding: 5px 0;
    }
  }
  .v-select__selection {
    font-size: 13px;
    margin: 6px 0 6px 10px;
    white-space: nowrap;
  }
  &__item {
    span {
      cursor: pointer;
      // display: block;
      // border: 1px solid #ccc;
      // padding: 2px 15px;
      // border-radius: 15px;
      color: #aaa;
      // background: transparent;
      // transition: all 0.3s ease;
    }
    &-button {
      margin: 0 !important;
      box-shadow: 0 0 0 !important;
      cursor: pointer;
      display: block;
      border: 1px solid #ccc;
      padding: 6px 10px 5px !important;
      border-radius: 15px !important;
      background: transparent !important;
      transition: all 0.3s ease;
      height: auto !important;
      min-width: 10px;

      &::before {
        display: none;
      }

      &:hover {
        border-color: #000 !important;

        .v-btn__content {
          color: #000 !important;
        }
      }

      .v-btn__content {
        padding: 0 !important;
        color: #aaa !important;
        font-weight: 400 !important;
      }

      .v-ripple__container {
        display: none !important;
      }
    }

    &--active:not(.filters--disabled) {
      .filters__item-button {
        border-color: #404ce6 !important;
        background: #404ce6 !important;
        .v-btn__content {
          color: #fff !important;
        }

        &:hover {
          border-color: #404ce6 !important;
          background: #404ce6 !important;

          .v-btn__content {
            color: #fff !important;
          }
        }
      }
    }
  }

  &__search {
    &-select {
      max-width: 100px;
    }

    &-button {
      margin: 0 !important;
      box-shadow: 0 0 0 !important;
      cursor: pointer;
      display: block;
      border: 1px solid #ccc;
      padding: 3px 15px 3px !important;
      border-radius: 15px !important;
      background: transparent !important;
      transition: all 0.3s ease;
      height: auto;
      min-width: 10px;

      &::before {
        display: none;
      }

      &:hover {
        border-color: #000 !important;

        .v-btn__content {
          color: #000 !important;
        }
      }

      .v-btn__content {
        padding: 0 !important;
        color: #aaa !important;
        font-weight: 400 !important;
      }
      .v-ripple__container {
        display: none !important;
      }
    }
  }
}

.winners {
  .theme--light.v-table tbody tr:not(:last-child) {
    border: 0;
  }
  &__date {
    max-width: 150px !important;
  }
  &__table {
    thead {
      tr:hover {
        background: #fff !important;
      }
    }
    tr {
      background: #fff !important;
      cursor: pointer;

      &[active] {
        background: #fff !important;
      }
      position: relative;
      &:hover {
        background: rgba(74, 116, 252, 0.1) !important;
        .products__table-line {
          opacity: 1;
        }
        .products__table-actions {
          opacity: 1;
        }
      }
      // td:nth-child(1),
      // th:nth-child(1) {
      //     padding: 0 0 0 32px !important;
      //     position: relative;
      //     .v-icon {
      //         color: transparent !important;
      //     }
      //     .v-input--selection-controls__ripple {
      //         display: inline-block;
      //         vertical-align: middle;
      //         color: transparent;
      //         border: 1px solid #ccc;
      //         height: 14px;
      //         width: 14px;
      //         border-radius: 0;
      //         top: -2px;
      //         left: -2px;
      //         &::after {
      //             content: "";
      //             position: absolute;
      //             top: 1px;
      //             right: 1px;
      //             bottom: 1px;
      //             left: 1px;
      //             background: #4b74ff;
      //             opacity: 0;
      //         }
      //         &.accent--text {
      //             &::after {
      //                 opacity: 1;
      //             }
      //         }
      //     }
      // }
      // td:nth-child(2),
      // th:nth-child(2) {
      //     padding-left: 0 !important;
      // }
      th {
        font-size: 12px !important;
        &.active {
          color: #4b74ff !important;
        }
      }
      &:nth-child(2n + 2),
      &[active]:nth-child(2n + 2) {
        background: #f5f5f5 !important;
      }
    }
    &-actions {
      opacity: 0;
      font-size: 14px !important;
      padding-right: 32px !important;
      text-align: right;
      &-trigger {
        color: #ff0000;
        cursor: pointer;
        .v-icon {
          font-size: 16px;
          margin-right: 2px;
        }
      }
      &-confirm {
        padding: 20px 24px;
        border-radius: 4px;
        background: #fff;
        text-align: right;
        width: 370px;
      }
      &-title {
        text-align: center;
        padding-bottom: 16px;
      }
      &-message {
        float: left;
        max-width: 40%;
        font-size: 12px;
        color: #ff0000;
        text-align: left;
      }
    }
    &-pagination {
      display: inline-block;
      vertical-align: top;
      text-align: center;
      height: 32px;
      width: 32px;
      border-radius: 2px;
      border: 1px solid #aaa;
      margin: 0 10px;
      cursor: pointer;
      &::after {
        content: "";
        display: inline-block;
        vertical-align: top;
        border: 1px solid #666;
        border-width: 1px 1px 0 0;
        height: 6px;
        width: 6px;
        margin-top: 7px;
        position: relative;
      }
      &--left {
        &::after {
          transform: rotate(-135deg);
          right: -1px;
        }
      }
      &--right {
        &::after {
          transform: rotate(45deg);
          left: -1px;
        }
      }
      &--disabled {
        border-color: #eee;
        cursor: no-drop;
        &::after {
          border-color: #eee;
        }
      }
      &-text {
        display: inline-block;
        vertical-align: top;
        margin-top: 5px;
        min-width: 100px;
        text-align: center;
      }
      &-select {
        min-width: 20px;
      }
    }
    &-line {
      width: 3px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #4b74ff;
      opacity: 0;
    }

    &-contacts {
      background: none !important;
      color: #ff0000 !important;
      box-shadow: 0 0 0 !important;
      border: 0 !important;
      display: inline-block;
      vertical-align: top;
      padding: 0;
      height: auto;
      min-width: 10px;

      .v-ripple__container {
        display: none !important;
      }
      .v-btn__content {
        padding: 0 !important;
      }
      &::before {
        display: none;
      }
    }
    &-offer {
      white-space: nowrap;
    }
    &-date {
      white-space: nowrap;
    }
  }

  &__not-found {
    padding-top: 200px;
  }
  &--empty {
    min-height: 500px;
    line-height: 500px;
    vertical-align: middle;
    text-align: center;
  }
}

.btn {
  display: inline-block;
  vertical-align: top;
  border: 1px solid #ff0000;
  background: #ff0000;
  padding: 5px 15px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px;
  &--ghost {
    background: none;
    border-color: #ccc;
    color: #aaa;
  }
}
.theme--light.v-table {
  background: rgba(255, 255, 255, 0.7) !important;
}
// .v-text-field > .v-input__control > .v-input__slot:before,
// .v-text-field > .v-input__control > .v-input__slot:after {
//     display: none;
// }
// .v-input--selection-controls__input {
//     .v-icon {
//         color: transparent !important;
//     }
// }
// .v-input--selection-controls__ripple {
//     display: inline-block;
//     vertical-align: middle;
//     color: transparent;
//     border: 1px solid #ccc;
//     height: 14px;
//     width: 14px;
//     border-radius: 0;
//     top: -2px;
//     left: -2px;
//     &::after {
//         content: "";
//         position: absolute;
//         top: 1px;
//         right: 1px;
//         bottom: 1px;
//         left: 1px;
//         background: #4b74ff;
//         opacity: 0;
//     }
//     &.accent--text,
//     &.primary--text {
//         &::after {
//             opacity: 1;
//         }
//     }
// }
.v-list__tile__action {
  min-width: 32px;
  position: relative;
}
.v-list__tile {
  height: 40px;
}
.v-list__tile__title {
  line-height: 16px;
  height: 16px;
}
.select-all {
  top: 5px;
}
.v-text-field .v-input__append-inner {
  padding: 0;
  margin: 2px 0 0;
}
.v-list--disabled {
  opacity: 0.6;
}
.is_client {
  font-weight: 700;
}
</style>
